var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{staticClass:"text-sm-left",attrs:{"cols":"12","sm":"5","lg":"3"}},[_c('label',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.label))])]),_c('v-col',{attrs:{"cols":"12","sm":"7","lg":"9"}},[_vm._t("default")],2)],1),(_vm.line)?_c('v-divider',{staticClass:"my-3"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }